module.exports = __webpack_public_path__ + "img/pc-textlink-02.2ccc20c5.svg";